import { render, staticRenderFns } from "./Enlace.vue?vue&type=template&id=f71eaf48&scoped=true&"
import script from "./Enlace.vue?vue&type=script&lang=js&"
export * from "./Enlace.vue?vue&type=script&lang=js&"
import style0 from "./Enlace.vue?vue&type=style&index=0&id=f71eaf48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f71eaf48",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VMain})
